import { MenuItem } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  alignItems: 'center',
  lineHeight: 1.5,
  paddingLeft: theme.spacing(2.25),
  '&:hover': {
    color: '#434343',
    backgroundColor: 'transparent',
    '& .MuiSvgIcon-root': {
      opacity: '.4',
      transition: '0.3s',
    },
  },
  '& a': {
    width: '100%',
  },
}))
